import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../reports.service';
import { Observable, combineLatest, of } from 'rxjs';
import { IPortfolioAnalysis } from '../reports-models';
import { AppService } from 'src/app/services/app.service';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { UtilsService } from 'src/app/shared/utils.service';
import { GlobalSpinnerService } from 'src/app/shared/global-spinner/global-spinner.service';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { MessageToUiService } from 'src/app/services/message-to-ui.service';
import { LocalizationService } from 'src/app/shared/localization/localization.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DebtorsAgesChartComponent } from './charts/debtors-ages-chart/debtors-ages-chart.component';
import { BusinessSectorsComponent } from './charts/business-sectors/business-sectors.component';
import { QuartersTotalsComponent } from './charts/quarters-totals/quarters-totals.component';
import { QuartersCaseRegistrationComponent } from './charts/quarters-case-registration/quarters-case-registration.component';
import { QuartersSuccessRateComponent } from './charts/quarters-success-rate/quarters-success-rate.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-portfolio-analysis',
  templateUrl: './portfolio-analysis.component.html',
  styleUrls: ['./portfolio-analysis.component.scss'],
  imports: [CommonModule, TranslateModule, DebtorsAgesChartComponent, DebtorsAgesChartComponent, BusinessSectorsComponent, QuartersTotalsComponent, QuartersCaseRegistrationComponent,
    QuartersSuccessRateComponent, MatTooltipModule
  ]
})
export class PortfolioAnalysisComponent implements OnInit {

  portfolioAnalysis$: Observable<IPortfolioAnalysis>;
  customerNumber$ = this.appService.customerNumber$;
  textColor = this.utilsService.readCssStyleProperty('--clr-text-1');
  fontOptions = {
    weight: window.getComputedStyle(document.body).getPropertyValue('--fw-bold'),
    size: 14,
    family: 'asap-semibold',
  };

  constructor(
    private reportsService: ReportsService,
    private appService: AppService,
    private utilsService: UtilsService,
    private spinnerService: GlobalSpinnerService,
    private notificationService: MessageToUiService,
    private localizationService: LocalizationService
  ) { }

  ngOnInit(): void {
    this.portfolioAnalysis$ =
      combineLatest([
        this.customerNumber$,
        this.localizationService.currentLanguage$
      ])
        .pipe(switchMap(([
          customerNumber,
          languageCode
        ]) => {
          this.spinnerService.show();
          return this.reportsService.getPortfolioAnalysisData(languageCode, customerNumber).pipe(
            finalize(() => this.spinnerService.hide())
            , catchError(() => {
              this.notificationService.genericError();
              return of(null);
            }));
        }));
  }

  downloadGraphsAsPDF() {
    const data = document.getElementById('pdf-target');

    html2canvas(data).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      const pdf = new jspdf('p', 'mm', 'a4');

      const imgWidth = 250;
      const imgHeight = canvas.height * imgWidth / canvas.width;

      pdf.addImage(contentDataURL, 'PNG', 0, 0, imgWidth, imgHeight)

      pdf.save('portfolio-analysis.pdf');
    })
  }
}
